import Page from "webPage/Page";
import ContactModal from "modal/ContactModal";

Page.register("page-template-homepage", () => {
    $('body').on('click', '.js-contact-modal', function () {
        (new ContactModal($(this))).show();
        return false;
    });

    if ($(".js-offices").length > 0) {
        try {
            window.Offices = JSON.parse($(".js-offices").text());
        } catch (e) {
            console.warn("Couldn't load data from page", e);
        }
    }
});